export class DiagnosticBag {
    constructor() {
        this.diagnostics = [];
    }
    add(code, message, span, severity = 'error') {
        const diagnostic = { code, message, severity };
        if (span !== undefined)
            diagnostic.span = span;
        this.diagnostics.push(diagnostic);
    }
    hasErrors() {
        return this.diagnostics.some((d) => d.severity === 'error');
    }
    all() {
        return [...this.diagnostics];
    }
    merge(other) {
        const incoming = Array.isArray(other) ? other : other.all();
        this.diagnostics.push(...incoming);
    }
}
export function ok(value) {
    return { ok: true, value };
}
export function err(diagnostics) {
    return { ok: false, diagnostics };
}
export function spanFromOffsets(source, start, end) {
    let line = 1;
    let column = 1;
    for (let i = 0; i < start && i < source.length; i += 1) {
        if (source[i] === '\n') {
            line += 1;
            column = 1;
        }
        else {
            column += 1;
        }
    }
    return { start, end, line, column };
}
export function combineSpans(a, b) {
    return {
        start: Math.min(a.start, b.start),
        end: Math.max(a.end, b.end),
        line: a.start <= b.start ? a.line : b.line,
        column: a.start <= b.start ? a.column : b.column,
    };
}
